import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../../endpoints/Auth/functions";
import "../UserAccess.css";
import AccessContainer from "../AccessContainer";
import FormContent from "./FormContent";
const ForgotContent = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    username: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let result = await forgotPassword(formData);
    if (result && result.status === 200) {
      setFormData({ email: "", username: "", password: "" });
      navigate("/login");
    }
    setLoading(false);
  };
  return (
    <AccessContainer>
      <FormContent
        handleSubmit={handleSubmit}
        loading={loading}
        formData={formData}
        setFormData={setFormData}
      />
    </AccessContainer>
  );
};

export default ForgotContent;
